var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "settings" }, [
    _c(
      "form",
      {
        on: {
          submit: function($event) {
            $event.preventDefault()
            return _vm.submitSettings($event)
          }
        }
      },
      [
        _c("div", { staticClass: "title" }, [
          _vm._v("\n      Настройки для доставки\n    ")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group row col-gutters-xs" }, [
          _c("div", { staticClass: "form-group__label label col-xs-3" }, [
            _vm._v("\n        Адрес магазина\n      ")
          ]),
          _vm._v(" "),
          _c("div", {
            staticClass: "form-group__control col-xs-9",
            domProps: { textContent: _vm._s(_vm.storeAddress) }
          })
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-group row col-gutters-xs" },
          [
            _c("div", { staticClass: "form-group__label label col-xs-9" }, [
              _vm._v("\n        Горизонт доставки, дней\n      ")
            ]),
            _vm._v(" "),
            _c("q-input", {
              staticClass: "form-group__control col-xs-3",
              attrs: { square: "", outlined: "", dense: "" },
              model: {
                value: _vm.vDeliveryHorizont,
                callback: function($$v) {
                  _vm.vDeliveryHorizont = $$v
                },
                expression: "vDeliveryHorizont"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "title" }, [
          _vm._v("\n      Ограничение по габаритам (для каждого товара)\n    ")
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-group row col-gutters-xs" },
          [
            _c("div", { staticClass: "form-group__label label col-xs-9" }, [
              _vm._v("\n        Высота, см\n      ")
            ]),
            _vm._v(" "),
            _c("q-input", {
              staticClass: "form-group__control col-xs-3",
              attrs: { square: "", outlined: "", dense: "" },
              model: {
                value: _vm.vHeight,
                callback: function($$v) {
                  _vm.vHeight = $$v
                },
                expression: "vHeight"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-group row col-gutters-xs" },
          [
            _c("div", { staticClass: "form-group__label label col-xs-9" }, [
              _vm._v("\n        Длина, см\n      ")
            ]),
            _vm._v(" "),
            _c("q-input", {
              staticClass: "form-group__control col-xs-3",
              attrs: { square: "", outlined: "", dense: "" },
              model: {
                value: _vm.vLength,
                callback: function($$v) {
                  _vm.vLength = $$v
                },
                expression: "vLength"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-group row col-gutters-xs" },
          [
            _c("div", { staticClass: "form-group__label label col-xs-9" }, [
              _vm._v("\n        Ширина, см\n      ")
            ]),
            _vm._v(" "),
            _c("q-input", {
              staticClass: "form-group__control col-xs-3",
              attrs: { square: "", outlined: "", dense: "" },
              model: {
                value: _vm.vWidth,
                callback: function($$v) {
                  _vm.vWidth = $$v
                },
                expression: "vWidth"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "title" }, [
          _vm._v("\n      Ограничение для заказа\n    ")
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-group row col-gutters-xs" },
          [
            _c("div", { staticClass: "form-group__label label col-xs-9" }, [
              _vm._v("\n        Объём, м3\n      ")
            ]),
            _vm._v(" "),
            _c("q-input", {
              staticClass: "form-group__control col-xs-3",
              attrs: { square: "", outlined: "", dense: "" },
              model: {
                value: _vm.vVolume,
                callback: function($$v) {
                  _vm.vVolume = $$v
                },
                expression: "vVolume"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-group row col-gutters-xs" },
          [
            _c("div", { staticClass: "form-group__label label col-xs-9" }, [
              _vm._v("\n        Вес, кг\n      ")
            ]),
            _vm._v(" "),
            _c("q-input", {
              staticClass: "form-group__control col-xs-3",
              attrs: { square: "", outlined: "", dense: "" },
              model: {
                value: _vm.vWeight,
                callback: function($$v) {
                  _vm.vWeight = $$v
                },
                expression: "vWeight"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "col-xs-12 actions" }, [
          _c("div", { staticClass: "row reverse" }, [
            _c(
              "div",
              { staticClass: "col-sm-3 col-xs-12" },
              [
                _c("q-btn", {
                  staticClass: "full-width",
                  attrs: {
                    type: "submit",
                    size: "16px",
                    label: "Сохранить",
                    unelevated: "",
                    color: "primary"
                  }
                })
              ],
              1
            )
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }